<template>
  <div class="page-content free-study-page">
    <div class="content-wrap" v-loading="pageLoading">
        <div class="page-title d-flex d-flex-middle">
          <span class="title-bar"></span>
          <span class="title-text">专业计划</span>
        </div>
        <div class="course-info-card">
          <div class="course-header-row">
            <div class="course-icon" aria-hidden="true">
              <i class="el-icon-reading"></i>
            </div>
            <p class="course-title">{{ courseInfo.courseCode + ' - ' + courseInfo.courseName }}</p>
          </div>
          <div class="course-meta">
            <span class="meta-item">
              <span class="meta-label">课程类型：</span>
              <span class="meta-value">{{ courseInfo.courseTypeName || '' }}</span>
            </span>
            <span class="meta-item">
              <span class="meta-label">学分：</span>
              <span class="meta-value">{{ courseInfo.score || 0 }}</span>
            </span>
            <span class="meta-item">
              <span class="meta-label">课件：</span>
              <span class="meta-value">{{ courseInfo.chapterCount || 0 }}章{{ courseInfo.totalLessons || 0 }}节</span>
            </span>
            <span class="meta-item meta-item--link" @click="openWrongModal">
              <span class="meta-label">错题集：</span>
              <span class="meta-value meta-value--danger">{{ courseInfo.wrongCount || 0 }}题</span>
            </span>
            <span class="meta-item meta-item--link" @click="openFavModal">
              <span class="meta-label">收藏夹：</span>
              <span class="meta-value meta-value--accent">{{ courseInfo.favCount || 0 }}题</span>
            </span>
          </div>
        </div>

        <!-- <div class="study-tabs">
          <div class="tab" :class="{ active: activeTab === 'video' }" @click="activeTab = 'video'">
            <span class="tab-icon">▶</span> 课件学习
          </div>
          <div class="tab" :class="{ active: activeTab === 'paper' }" @click="activeTab = 'paper'">
            <span class="tab-icon">📝</span> 试题练习
          </div>
        </div> -->

        <div class="tab-content" v-show="activeTab === 'video'">
          <div class="video-area" v-if="courseInfo.coursewareId">
            <div class="video-player" :class="{ dis: currentLesson.id && !currentLesson.isFinished }">
              <video ref="videoBoxRef" id="freeVideoPlayer" class="video-js vjs-fluid vjs-big-play-centered"
                style="width: 100%; height: 100%;" controls preload="auto" autoplay :loop="false"></video>
            </div>
            <div class="chapter-sidebar">
              <!-- <div class="sidebar-tabs">
                <div class="sidebar-tab" :class="{ active: videoSideTab === 1 }" @click="videoSideTab = 1">目录</div>
                <div class="sidebar-tab" :class="{ active: videoSideTab === 2 }" @click="videoSideTab = 2">留言</div>
              </div> -->
              <div class="sidebar-tab-panel" v-show="videoSideTab === 1">
                <div class="chapter" v-for="(chapter, ci) in chapterList" :key="ci">
                  <div
                    class="chapter-name"
                    :class="{ expanded: chapter.expanded }"
                    @click="toggleChapter(ci)"
                  >
                    <span class="chapter-title">
                      <span class="chapter-no">{{ formatChapterNo(ci) }}</span>
                      <span class="chapter-label">{{ chapter.name }}</span>
                    </span>
                    <span class="chapter-arrow" :class="{ open: chapter.expanded }">
                      <img src="@/assets/freeStudy_bottom.png" alt="" class="arrow">
                    </span>
                  </div>
                  <div class="lessons" v-show="chapter.expanded">
                    <div
                      class="lesson"
                      :class="{ active: currentLessonIndex === li && currentChapterIndex === ci }"
                      v-for="(lesson, li) in chapter.lessons"
                      :key="li"
                      @click="selectLesson(ci, li)"
                    >
                      <span class="lesson-icon" aria-hidden="true">
                        <img
                          :src="currentLessonIndex === li && currentChapterIndex === ci
                            ? require('@/assets/freeStudy_playing.png')
                            : require('@/assets/freeStudy_play.png')"
                          alt=""
                        >
                      </span>
                      <span class="lesson-name">
                        {{ lesson.name }}{{ formatLessonProgress(lesson) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="sidebar-tab-panel sidebar-tab-panel--qa" v-show="videoSideTab === 2">
                <div class="qa-comment">
                  <div v-if="!commentList.length" class="qa-empty">
                    <i class="el-icon-chat-dot-round qa-empty-icon" aria-hidden="true"></i>
                    <p class="qa-empty-title">还没有留言</p>
                    <p class="qa-empty-hint">有问题可在下方输入，教师会看到并回复</p>
                  </div>
                  <article
                    v-for="(item, idx) in commentList"
                    :key="item.id || idx"
                    class="qa-thread"
                  >
                    <div class="qa-row">
                      <div
                        class="qa-avatar qa-avatar--root"
                        :aria-label="commentAuthorLabel(item)"
                      >
                        {{ qaAvatarInitial(commentAuthorLabel(item)) }}
                      </div>
                      <div class="qa-body">
                        <header class="qa-head">
                          <div class="qa-head-left">
                            <span class="qa-nick qa-nick--student">{{ commentAuthorLabel(item) }}</span>
                            <span class="qa-badge-lv qa-badge-lv--stu">学员</span>
                          </div>
                          <time class="qa-time">{{ item.createTime }}</time>
                        </header>
                        <p class="qa-content">{{ item.content }}</p>
                      </div>
                    </div>
                    <div v-if="sortedReplies(item).length" class="qa-reply-wrap">
                      <div
                        v-for="rep in sortedReplies(item)"
                        :key="rep.id"
                        class="qa-row qa-row--reply"
                      >
                        <div
                          class="qa-avatar qa-avatar--reply"
                          :aria-label="rep.teacher || '教师'"
                        >
                          {{ qaAvatarInitial(rep.teacher || '教') }}
                        </div>
                        <div class="qa-body">
                          <header class="qa-head">
                            <div class="qa-head-left">
                              <span class="qa-nick qa-nick--teacher">{{ rep.teacher || '教师' }}</span>
                              <span class="qa-badge-lv qa-badge-lv--teacher">教师</span>
                            </div>
                            <time class="qa-time">{{ rep.createTime }}</time>
                          </header>
                          <p class="qa-content">{{ rep.content }}</p>
                        </div>
                      </div>
                    </div>
                    <div v-else-if="item.replyName" class="qa-reply-wrap">
                      <div class="qa-row qa-row--reply">
                        <div class="qa-avatar qa-avatar--reply" :aria-label="item.replyName">
                          {{ qaAvatarInitial(item.replyName) }}
                        </div>
                        <div class="qa-body">
                          <header class="qa-head">
                            <div class="qa-head-left">
                              <span class="qa-nick qa-nick--teacher">{{ item.replyName }}</span>
                              <span class="qa-badge-lv qa-badge-lv--teacher">教师</span>
                            </div>
                            <time class="qa-time">{{ item.replyTime }}</time>
                          </header>
                          <p class="qa-content">{{ item.replyContent }}</p>
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
                <div class="qa-compose">
                  <el-input
                    class="qa-compose-inp"
                    size="small"
                    v-model="commentContent"
                    placeholder="输入留言内容…"
                    clearable
                    @keyup.enter.native="handleCommentSubmit"
                  />
                  <el-button
                    class="qa-compose-btn"
                    type="primary"
                    size="small"
                    @click="handleCommentSubmit"
                  >
                    发送
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <el-empty description="暂无课件" v-else></el-empty>
        </div>

        <div class="tab-content" v-show="activeTab === 'paper'">
          <div class="paper-area" v-if="paperList.length > 0">
            <ul class="paper-list">
              <li class="paper-item" v-for="(paper, pi) in paperList" :key="pi">
                <div class="paper-info">
                  <p class="paper-name">{{ paper.name }}</p>
                  <div class="paper-meta">
                    <span>题量：{{ paper.questionCount }}题</span>
                    <span v-if="paper.hasSubjective">含主观题</span>
                  </div>
                  <template v-if="paper.lastRecord">
                    <p class="last-record">上次练习：客观题正确率 {{ paper.lastRecord.correctRate }}% | {{ paper.lastRecord.time }}</p>
                    <div class="paper-stats">
                      <span>练习次数：<a href="javascript:void(0);" class="link-btn" @click="viewPaperRecord(paper)">{{ paper.practiceCount }}</a></span>
                    </div>
                  </template>
                </div>
                <div style="display:flex;flex-direction:column;gap:8px;align-items:flex-end;">
                  <div v-if="paper.lastRecord" style="display:flex;gap:10px;">
                    <button class="paper-btn" @click="continuePaper(paper)">继续</button>
                  </div>
                  <button v-else class="paper-btn" @click="openModeDialog(paper)">开始</button>
                </div>
              </li>
            </ul>
          </div>
          <el-empty description="暂无试题" v-else></el-empty>
        </div>
    </div>

    <div class="confirm-overlay" v-if="confirmVisible" @click.self="closeConfirm">
      <div class="confirm-box">
        <div class="confirm-icon warn">⚠</div>
        <p class="confirm-title">{{ confirmTitle }}</p>
        <p class="confirm-desc">{{ confirmDesc }}</p>
        <div class="confirm-actions">
          <button class="btn btn-cancel" @click="closeConfirm">取消</button>
          <button class="btn btn-danger" @click="doConfirm">确定</button>
        </div>
      </div>
    </div>

    <WrongModal :visible.sync="wrongModalVisible" :courseId="courseId" @deleted="getCourseInfo" />
    <FavModal :visible.sync="favModalVisible" :courseId="courseId" @deleted="getCourseInfo" />

    <div class="mode-overlay" v-if="modeDialogVisible" @click.self="closeModeDialog">
      <div class="mode-dialog" @click.stop>
        <div class="md-title">选择练习模式</div>
        <div class="md-options">
          <div class="md-opt mode-answer" @click="confirmMode('answer')">
            <div class="md-icon">✎</div>
            <div class="md-name">答题模式</div>
            <div class="md-desc">模拟真实考试，检验学习成果</div>
          </div>
          <div class="md-opt mode-back" @click="confirmMode('back')">
            <div class="md-icon">👁</div>
            <div class="md-name">背题模式</div>
            <div class="md-desc">直接查看答案，快速记忆知识点</div>
          </div>
        </div>
        <button class="md-cancel" @click="closeModeDialog">取消</button>
      </div>
    </div>

  </div>
</template>

<script>
import WrongModal from "./components/WrongModal.vue";
import FavModal from "./components/FavModal.vue";
import videojs from "video.js";
import "videojs-contrib-hls";
import "video.js/dist/video-js.css";
import "videojs-flvjs-es6";

/** 每累计多少秒「有效播放」上报一次（由定时器在播放中累加，与视频 currentTime 无关） */
const ACHIEVE_PLAYBACK_SEC = 60;
/** 定时器步长（毫秒），与累加秒数一致：每 tick 增加 1 秒播放量 */
const ACHIEVE_TICK_MS = 1000;

export default {
  name: "courseDetail",
  components: {
    WrongModal,
    FavModal,
  },
  data() {
    return {
      courseId: '',
      activeTab: 'video',
      courseInfo: {},
      chapterList: [],
      currentChapterIndex: -1,
      currentLessonIndex: -1,
      currentLesson: {},
      videoPlayer: null,
      /** 自上次成功上报以来累计的有效播放秒数（仅播放中由定时器增加） */
      achievePlaybackAccumSec: 0,
      achieveRequestInFlight: false,
      /** setInterval 句柄；启动前必须先 clear，避免重复计时 */
      achievePlaybackIntervalId: null,
      paperList: [],
      wrongModalVisible: false,
      favModalVisible: false,
      modeDialogVisible: false,
      pendingPaper: null,
      confirmVisible: false,
      confirmTitle: '',
      confirmDesc: '',
      confirmCallback: null,
      pageLoading: false,
      videoSideTab: 1,
      commentContent: '',
      commentList: [],
    };
  },
  created() {
    this.courseId = this.$route.query.courseId;
    if (!this.courseId) {
      this.$message.warning('课程参数缺失，即将返回');
      this.$router.replace('/main/specialtyPlan');
      return;
    }
    this.getCourseInfo();
    this.getPaperList();
  },
  /** 同一路由仅 query（如 courseId）变化时会复用实例，created 不会再次执行 */
  beforeRouteUpdate(to, from, next) {
    const nextId = to.query.courseId;
    if (nextId && String(nextId) !== String(this.courseId)) {
      this.courseId = nextId;
      this.chapterList = [];
      this.currentChapterIndex = -1;
      this.currentLessonIndex = -1;
      this.currentLesson = {};
      this.courseInfo = {};
      this.commentList = [];
      this.clearAchieveSchedule();
      if (this.videoPlayer) {
        try {
          this.videoPlayer.dispose();
        } catch (e) {
          /* ignore */
        }
        this.videoPlayer = null;
      }
      this.getCourseInfo();
      this.getPaperList();
    }
    next();
  },
  destroyed() {
    this.clearAchieveSchedule();
    if (this.videoPlayer) {
      this.videoPlayer.dispose();
      this.videoPlayer = null;
    }
  },
  methods: {
    getCourseInfo() {
      this.pageLoading = true;
      this.$http.get('/student/pc/freeStudy/courseInfo', { courseId: this.courseId }).then(res => {
        if (res) {
          this.courseInfo = res;
          if(res.coursewareId){
            this.getChapterList();
            this.getComment();
          }
        }
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    getChapterList() {
      const coursewareId = this.courseInfo && this.courseInfo.coursewareId;
      if (!coursewareId) {
        this.chapterList = [];
        return;
      }
      this.$http.get('/student/pc/freeStudy/chapters', { coursewareId }).then(res => {
        if (!Array.isArray(res)) {
          this.chapterList = [];
          return;
        }
        this.chapterList = res.map((chapter) => ({
          ...chapter,
          expanded: false,
          lessons: (chapter.lessons || []).map(lesson => ({
            ...lesson,
            minutes: lesson.minutes || lesson.totalDuration || 0,
            isFinished: !!lesson.isFinished,
          })),
        }));
        // 等章节列表渲染后再选节，避免 #freeVideoPlayer 尚未挂载时 initVideo 取不到节点
        this.$nextTick(() => {
          this.setLive();
        });
      });
    },
    setLive() {
      if (!this.chapterList || !this.chapterList.length) {
        return;
      }
      const picked = this.chapterList.some((z, zi) => {
        return (z.lessons || []).some((j, ji) => {
          if (!j.isFinished) {
            this.toggleChapter(zi, true);
            this.selectLesson(zi, ji);
            return true;
          }
          return false;
        });
      });
      // 全部标记已学完时也要默认选中第一节，否则播放器无源、用户误以为 setLive 未执行
      if (!picked) {
        const first = this.chapterList[0];
        const lessons = first && first.lessons;
        if (lessons && lessons.length) {
          this.toggleChapter(0, true);
          this.selectLesson(0, 0);
        }
      }
    },
    getPaperList() {
      this.$http.get('/student/pc/freeStudy/papers', { courseId: this.courseId }).then(res => {
        if (res) {
          this.paperList = res || [];
        }
      });
    },
    toggleChapter(index, forceOpen) {
      this.$set(this.chapterList[index], 'expanded', forceOpen || !this.chapterList[index].expanded);
    },
    formatChapterNo(index) {
      const n = index + 1;
      const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      if (n <= 0) return '';
      if (n < 10) return `第${digits[n]}章`;
      if (n === 10) return '第十章';
      if (n < 20) return `第十${digits[n - 10]}章`;
      return `第${n}章`;
    },
    formatLessonProgress(lesson) {
      const learned = Math.floor(Number(lesson && lesson.duration) || 0);
      const total = Math.floor(Number(lesson && lesson.minutes) || 0);
      return ` (${learned}/${total}分钟)`;
    },
    getVideoFormatRegex(url) {
      const flvRegex = /\.(flv)$/i;
      const m3u8Regex = /\.(m3u8)$/i;
      if (flvRegex.test(url)) {
        return 'video/x-flv';
      } else if (m3u8Regex.test(url)) {
        return 'application/x-mpegURL';
      } else {
        return '';
      }
    },
    selectLesson(chapterIndex, lessonIndex) {
      // 仅当已是当前节且播放器已就绪时才跳过；避免 videoPlayer 已 dispose 或尚未 init 时误跳过
      if (
        this.currentChapterIndex === chapterIndex &&
        this.currentLessonIndex === lessonIndex &&
        this.videoPlayer
      ) {
        return;
      }
      this.clearAchieveSchedule();
      this.currentChapterIndex = chapterIndex;
      this.currentLessonIndex = lessonIndex;
      this.currentLesson = this.chapterList[chapterIndex].lessons[lessonIndex];
      const src = this.currentLesson.filePath;
      if (src) {
        this.initVideo(src, this.getVideoFormatRegex(src));
      }
    },
    /** 切换视频后起播位置（秒）：已学完从 0，否则从已学 duration（分钟）换算 */
    getLessonResumeSeconds(lesson) {
      if (!lesson || lesson.isFinished) {
        return 0;
      }
      const m = Number(lesson.duration);
      if (!m || m <= 0) {
        return 0;
      }
      return m * 60;
    },
    /**
     * 将播放进度跳到当前课续播秒数。
     * 换源时必须在 src()/load() 之前注册 loadedmetadata，否则事件可能先触发导致监听永远不跑；
     * HLS 常在 canplay/loadeddata 后才能真正 seek，故多事件 + 短延时重试。
     */
    seekToLessonResume(player, startSec) {
      if (!player || startSec <= 0) {
        return;
      }
      const tick = () => {
        if (!this.videoPlayer || this.videoPlayer !== player) {
          return;
        }
        if (this.getLessonResumeSeconds(this.currentLesson) !== startSec) {
          return;
        }
        try {
          const d = player.duration();
          if (Number.isFinite(d) && d > 0 && startSec > d) {
            player.currentTime(Math.max(0, d - 0.5));
            return;
          }
          player.currentTime(startSec);
        } catch (e) {
          /* 部分源在 seekable 未就绪时会抛错，交给后续重试 */
        }
      };
      player.one('loadedmetadata', tick);
      player.one('loadeddata', tick);
      player.one('canplay', tick);
      this.$nextTick(tick);
      setTimeout(tick, 120);
      setTimeout(tick, 400);
      setTimeout(tick, 1200);
    },
    initVideo(src, type) {
      src = src.replace('http://', 'https://');
      const _this = this;
      if (this.videoPlayer) {
        const startSec = _this.getLessonResumeSeconds(_this.currentLesson);
        if (startSec > 0) {
          _this.seekToLessonResume(_this.videoPlayer, startSec);
        }
        this.videoPlayer.src({ src, type });
        this.videoPlayer.load();
        return;
      }
      this.$nextTick(() => {
        const options = {
          height: 530,
          fullscreen: {
            options: { navigationUI: "hide" },
          },
          techOrder: ["html5", "flvjs"],
          html5: {
            hls: {
              withCredentials: true,
            },
          },
          flvjs: {
            mediaDataSource: {
              isLive: false,
              cors: true,
              withCredentials: false,
            },
          },
          sources: [{ src, type }],
        };
        const videoElement = document.getElementById('freeVideoPlayer');
        _this.videoPlayer = videojs(videoElement, options, function onPlayerReady() {
          const startSec = _this.getLessonResumeSeconds(_this.currentLesson);
          if (startSec > 0) {
            _this.seekToLessonResume(_this.videoPlayer, startSec);
          }
          _this.videoPlayer.on('play', function () {
            _this.startAchievePlaybackTicker();
          });
          _this.videoPlayer.on('pause', function () {
            _this.stopAchievePlaybackTicker();
          });
          _this.videoPlayer.on('ended', function () {
            _this.clearAchieveSchedule();
            _this.onEnded();
          });
        });
      });
    },
    onEnded() {
      this.setLive();
    },
    clearAchieveSchedule() {
      this.stopAchievePlaybackTicker();
      this.achievePlaybackAccumSec = 0;
      this.achieveRequestInFlight = false;
    },
    stopAchievePlaybackTicker() {
      if (this.achievePlaybackIntervalId != null) {
        clearInterval(this.achievePlaybackIntervalId);
        this.achievePlaybackIntervalId = null;
      }
    },
    /** 仅在播放中运行；启动前会清掉旧 interval，避免重复 */
    startAchievePlaybackTicker() {
      this.stopAchievePlaybackTicker();
      if (!this.currentLesson || this.currentLesson.isFinished) {
        return;
      }
      const self = this;
      this.achievePlaybackIntervalId = setInterval(() => {
        self.onAchieveIntervalTick();
      }, ACHIEVE_TICK_MS);
    },
    onAchieveIntervalTick() {
      const v = this.videoPlayer;
      if (!v || v.paused()) {
        return;
      }
      if (!this.currentLesson || this.currentLesson.isFinished) {
        this.stopAchievePlaybackTicker();
        return;
      }
      this.achievePlaybackAccumSec += ACHIEVE_TICK_MS / 1000;
      const total = this.achievePlaybackAccumSec;
      const need = Math.max(0, ACHIEVE_PLAYBACK_SEC - total);
      //
      // console.log(
      //   '[freeStudy achieve] 定时器 +1s | 累计有效播放:',
      //   `${total.toFixed(1)}s`,
      //   '| 距满',
      //   `${ACHIEVE_PLAYBACK_SEC}s 上报还差:`,
      //   need > 0 ? `${need.toFixed(1)}s` : '已达阈值，将触发上报',
      // );
      this.tryFlushAchievePlayback();
    },
    tryFlushAchievePlayback() {
      if (!this.videoPlayer || !this.currentLesson || this.currentLesson.isFinished) {
        return;
      }
      if (this.achieveRequestInFlight) {
        return;
      }
      if (this.achievePlaybackAccumSec < ACHIEVE_PLAYBACK_SEC) {
        return;
      }
      // eslint-disable-next-line no-console
      // console.log(
      //   '[freeStudy achieve] 发起 videoProgress | 累计:',
      //   `${this.achievePlaybackAccumSec.toFixed(1)}s`,
      //   '| 阈值:',
      //   `${ACHIEVE_PLAYBACK_SEC}s`,
      // );
      this.achieveRequestInFlight = true;
      this.achieve()
        .then((res) => {
          if (!this.currentLesson || this.currentLesson.isFinished) {
            return;
          }
          if (res) {
            const before = this.achievePlaybackAccumSec;
            this.achievePlaybackAccumSec = Math.max(0, this.achievePlaybackAccumSec - ACHIEVE_PLAYBACK_SEC);
            // eslint-disable-next-line no-console
            // console.log(
            //   '[freeStudy achieve] 上报成功，扣减',
            //   `${ACHIEVE_PLAYBACK_SEC}s | 扣减前:`,
            //   `${before.toFixed(1)}s`,
            //   '→ 扣减后:',
            //   `${this.achievePlaybackAccumSec.toFixed(1)}s`,
            // );
          }
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          // console.warn('[freeStudy achieve] 上报失败，累计不扣减，当前:', `${this.achievePlaybackAccumSec.toFixed(1)}s`);
        })
        .finally(() => {
          this.achieveRequestInFlight = false;
          if (!this.currentLesson || this.currentLesson.isFinished) {
            return;
          }
          if (this.achievePlaybackAccumSec >= ACHIEVE_PLAYBACK_SEC) {
            this.$nextTick(() => this.tryFlushAchievePlayback());
          }
        });
    },
    achieve() {
      if (!this.currentLesson || this.currentLesson.isFinished) {
        return Promise.resolve();
      }
      const coursewareId = this.courseInfo && this.courseInfo.coursewareId;
      const chapter = this.chapterList[this.currentChapterIndex];
      if (!coursewareId || !chapter) {
        return Promise.resolve();
      }
      return this.$http.post_s("/student/pc/freeStudy/videoProgress", {
        coursewareId,
        chapterId: chapter.id,
        lessonId: this.currentLesson.id,
      }).then((res) => {
        if (!res) {
          return null;
        }
        const ci = (this.currentLesson.duration || 0) + 1;
        this.$set(this.currentLesson, 'isFinished', !!res.isFinished);
        this.$set(this.currentLesson, 'duration', res.duration || ci);
        if (res.isFinished) {
          this.clearAchieveSchedule();
          this.setLive();
        }
        return res;
      });
    },
    formatTime(seconds) {
      if (!seconds && seconds !== 0) return '0:00';
      const s = Math.floor(seconds);
      const m = Math.floor(s / 60);
      const sec = s % 60;
      return m + ':' + (sec < 10 ? '0' : '') + sec;
    },
    getRateClass(rate) {
      if (rate >= 80) return 'high';
      if (rate >= 60) return 'mid';
      return 'low';
    },
    getRateColor(rate) {
      if (rate >= 80) return '#67c23a';
      if (rate >= 60) return '$accent';
      return '#f56c6c';
    },
    openModeDialog(paper) {
      this.pendingPaper = paper;
      this.modeDialogVisible = true;
    },
    closeModeDialog() {
      this.modeDialogVisible = false;
      this.pendingPaper = null;
    },
    confirmMode(mode) {
      if (this.pendingPaper) {
        this.$router.push({
          path: '/main/freeStudyPaper',
          query: {
            paperId: this.pendingPaper.id,
            courseId: this.courseId,
            mode: mode,
          },
        });
      }
      this.closeModeDialog();
    },
    continuePaper(paper) {
      this.$router.push({
        path: '/main/freeStudyPaper',
        query: {
          paperId: paper.id,
          courseId: this.courseId,
          mode: 'answer',
        },
      });
    },
    viewPaperRecord(paper) {
      this.$router.push({
        path: '/main/paperResult',
        query: {
          paperId: paper.id,
          courseId: this.courseId,
        },
      });
    },
    openWrongModal() {
      this.wrongModalVisible = true;
    },
    openFavModal() {
      this.favModalVisible = true;
    },
    showConfirm(title, desc, callback) {
      this.confirmTitle = title;
      this.confirmDesc = desc;
      this.confirmCallback = callback;
      this.confirmVisible = true;
    },
    closeConfirm() {
      this.confirmVisible = false;
      this.confirmCallback = null;
    },
    doConfirm() {
      if (this.confirmCallback) {
        this.confirmCallback();
      }
      this.closeConfirm();
    },
    getComment() {
      const coursewareId = this.courseInfo && this.courseInfo.coursewareId;
      if (!coursewareId) {
        return;
      }
      this.$http.get('/student/pc/freeStudy/interaction/myMessages', { coursewareId }).then((res) => {
        this.commentList = Array.isArray(res) ? res : [];
      });
    },
    /** myMessages：主贴无 studentName 时用「我」；教师回复在 replies 数组内 */
    commentAuthorLabel(item) {
      return item.studentName || '我';
    },
    sortedReplies(item) {
      const list = item && item.replies;
      if (!Array.isArray(list) || !list.length) {
        return [];
      }
      return [...list].sort((a, b) => String(a.createTime || '').localeCompare(String(b.createTime || '')));
    },
    /** 头像内一字（参考评论区样式） */
    qaAvatarInitial(name) {
      const s = String(name || '').trim();
      if (!s) {
        return '?';
      }
      return s.slice(0, 1);
    },
    handleCommentSubmit() {
      const coursewareId = this.courseInfo && this.courseInfo.coursewareId;
      if (!coursewareId) {
        this.$message({
          showClose: true,
          message: '暂无课件，无法发送',
          type: 'error',
        });
        return;
      }
      if (!this.commentContent) {
        this.$message({
          showClose: true,
          message: '内容不能为空',
          type: 'error',
        });
        return;
      }
      this.$http
        .post('/student/pc/freeStudy/interaction/add', {
          coursewareId,
          content: this.commentContent,
        })
        .then(() => {
          this.commentContent = '';
          this.getComment();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/variable.scss";
.free-study-page { min-height: 639px; }
.content-wrap { width: 100%; overflow: hidden;background: #FFFFFF;box-shadow: 0px 3px 10px 0px rgba(153,153,153,0.25);border-radius: 10px;}
.mianbao { line-height: 30px; padding: 15px 0; }
.mianbao .dq { color: #666; font-size: 14px; }
.mianbao .mba { color: #666; font-size: 14px; padding: 0 5px; text-decoration: none; &:hover { color: $primary-dark; } }
.mianbao .site { color: $primary-dark; font-size: 14px; padding: 0 5px; }

.course-info-card {
  box-sizing: border-box;
  padding: 0 30px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.course-header-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.course-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #f59a23;
  display: flex;
  align-items: center;
  justify-content: center;
  i { color: #fff; font-size: 14px; }
}

.course-title {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  line-height: 1.3;
}

.course-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 60px;
  font-size: 14px;
  line-height: 1.5;
}

.meta-label { color: #999; }
.meta-value { color: #333; }

.meta-item--link {
  cursor: pointer;
  &:hover .meta-value--danger { color: darken($danger, 8%); }
  &:hover .meta-value--accent { color: darken($accent, 8%); }
}

.meta-value--danger {
  color: #e85d5d;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.meta-value--accent {
  color: $accent;
  text-decoration: underline;
  text-underline-offset: 2px;
}


.study-tabs {
  display: flex; background: #fff; overflow: hidden; border-bottom: 1px solid #e3e3e3;
  .tab {
    flex: 1; text-align: center; padding: 14px 0; font-size: 16px; cursor: pointer;
    color: #666; position: relative; transition: all .2s;
    display: flex; align-items: center; justify-content: center; gap: 8px; background: #fff;
    &.active { color: #fff; font-weight: bold; background: $primary-dark; }
    &:hover:not(.active) { color: $primary-dark; background: $primary-light; }
    .tab-icon { font-size: 18px; }
  }
}

.tab-content { background: #fff; border-top: none; min-height: 530px;margin-bottom: 30px; }

::v-deep .dis .vjs-progress-control {
  visibility: hidden;
}
.video-area { display: flex;box-sizing: border-box; padding: 20px 30px 0 30px; }
.video-player {
  flex: 1; min-width: 0; height: 530px; background: #262626;
  display: flex; align-items: center; justify-content: center; color: #fff; font-size: 16px; position: relative;
}

.chapter-sidebar {
  width: 320px;
  flex-shrink: 0;
  height: 530px;
  box-sizing: border-box;
  padding: 0 16px 0 20px;
  border-left: 1px solid #eaeaea;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .sidebar-tabs {
    display: flex;
    justify-content: center;
    padding: 10px 0;
    color: #333;
    border-bottom: 1px solid #eaeaea;
    flex-shrink: 0;
  }
  .sidebar-tab {
    flex: 1;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    &.active {
      position: relative;
      color: $primary-dark;
      font-weight: bold;
      &::after {
        content: '';
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        width: 28px;
        height: 3px;
        background-color: $primary-dark;
      }
    }
  }
  .sidebar-tab-panel {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    position: relative;
    overflow-x: hidden;
  }
  .sidebar-tab-panel--qa {
    display: flex;
    flex-direction: column;
    padding-top: 0;
    overflow: hidden;
    background: linear-gradient(180deg, #f8fafc 0%, #fff 22px);
  }

  .qa-comment {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    font-size: 13px;
    padding: 8px 4px 14px;
    line-height: 1.5;
    -webkit-overflow-scrolling: touch;
    color: #1e293b;
    scrollbar-width: thin;
  }

  .qa-empty {
    text-align: center;
    padding: 40px 18px 32px;
    margin: 8px 4px 0;
    border-radius: 12px;
    background: linear-gradient(160deg, rgba($primary-dark, 0.04) 0%, #fff 55%);
    border: 1px dashed rgba($primary-dark, 0.12);
    color: #64748b;
  }
  .qa-empty-icon {
    display: block;
    font-size: 40px;
    line-height: 1;
    margin: 0 auto 12px;
    color: rgba($primary-dark, 0.22);
  }
  .qa-empty-title {
    margin: 0 0 8px;
    font-size: 14px;
    font-weight: 600;
    color: #475569;
    letter-spacing: 0.02em;
  }
  .qa-empty-hint {
    margin: 0;
    font-size: 12px;
    line-height: 1.55;
    color: #94a3b8;
    max-width: 232px;
    margin-left: auto;
    margin-right: auto;
  }

  .qa-thread {
    padding: 12px 8px 14px;
    margin-bottom: 2px;
    border-radius: 12px;
    border: 1px solid transparent;
    transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
    &:hover {
      background: rgba(255, 255, 255, 0.9);
      border-color: #eef2f7;
      box-shadow: 0 1px 0 rgba(15, 23, 42, 0.04);
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .qa-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }
  .qa-row--reply {
    margin-top: 12px;
    &:first-child {
      margin-top: 2px;
    }
  }

  .qa-avatar {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 600;
    user-select: none;
    letter-spacing: 0;
  }
  .qa-avatar--root {
    width: 32px;
    height: 32px;
    font-size: 13px;
    margin-top: 2px;
    color: #3d4f5f;
    background: linear-gradient(145deg, #f1f5f9 0%, #e2e8f0 100%);
    box-shadow:
      0 0 0 2px #fff,
      0 0 0 3px rgba(148, 163, 184, 0.35),
      0 2px 6px rgba(15, 23, 42, 0.06);
  }
  .qa-avatar--reply {
    width: 26px;
    height: 26px;
    font-size: 11px;
    margin-top: 2px;
    color: #9d4b63;
    background: linear-gradient(145deg, #fff5f7 0%, #fce8ed 100%);
    box-shadow:
      0 0 0 2px #fff,
      0 0 0 3px rgba(251, 113, 153, 0.22),
      0 2px 5px rgba(15, 23, 42, 0.05);
  }

  .qa-body {
    flex: 1;
    min-width: 0;
    padding-top: 1px;
  }
  .qa-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 2px;
  }
  .qa-head-left {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    min-width: 0;
  }
  .qa-nick {
    font-size: 13px;
    font-weight: 600;
    line-height: 1.35;
    letter-spacing: 0.01em;
  }
  .qa-nick--student {
    color: $primary-dark;
  }
  .qa-nick--teacher {
    color: #d44d7a;
  }
  .qa-badge-lv {
    display: inline-block;
    padding: 1px 6px;
    font-size: 10px;
    font-weight: 700;
    line-height: 15px;
    border-radius: 4px;
    vertical-align: middle;
  }
  .qa-badge-lv--stu {
    color: #c2410c;
    background: linear-gradient(180deg, #fff7ed 0%, #ffedd5 100%);
    border: 1px solid rgba(251, 146, 60, 0.45);
  }
  .qa-badge-lv--teacher {
    color: #0369a1;
    background: linear-gradient(180deg, #f0f9ff 0%, #e0f2fe 100%);
    border: 1px solid rgba(56, 189, 248, 0.45);
  }

  .qa-content {
    margin: 4px 0 0 0;
    font-size: 13px;
    color: #1e293b;
    line-height: 1.62;
    word-break: break-word;
  }

  .qa-time {
    flex-shrink: 0;
    margin-top: 1px;
    font-size: 11px;
    color: #94a3b8;
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.01em;
  }

  /* 与主贴正文左缘对齐：头像 32px + 间距 8px */
  .qa-reply-wrap {
    margin-top: 10px;
    padding-left: 40px;
  }

  .qa-compose {
    display: flex;
    align-items: stretch;
    gap: 10px;
    flex-shrink: 0;
    padding: 12px 4px 14px;
    margin-top: auto;
    border-top: 1px solid #e8edf3;
    background: #fff;
    box-shadow: 0 -8px 24px rgba(15, 23, 42, 0.05);
  }
  .qa-compose-inp {
    flex: 1;
    min-width: 0;
  }
  .qa-compose-btn {
    flex-shrink: 0;
    padding-left: 18px;
    padding-right: 18px;
    border-radius: 10px;
    font-weight: 600;
  }

  ::v-deep .qa-compose-inp .el-input__inner {
    border-radius: 10px;
    border-color: #e2e8f0;
    background: #f8fafc;
    font-size: 13px;
    transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
    &:hover {
      background: #fff;
      border-color: #cbd5e1;
    }
    &:focus {
      background: #fff;
      border-color: rgba($primary-dark, 0.45);
      box-shadow: 0 0 0 3px rgba($primary-dark, 0.1);
    }
  }
  ::v-deep .qa-compose-btn.el-button--primary {
    background: linear-gradient(180deg, lighten($primary-dark, 6%) 0%, $primary-dark 100%);
    border: none;
    box-shadow: 0 2px 8px rgba($primary-dark, 0.28);
    &:hover {
      background: linear-gradient(180deg, lighten($primary-dark, 10%) 0%, lighten($primary-dark, 3%) 100%);
    }
  }
}

.chapter {
  margin-bottom: 8px;
  &:last-child { margin-bottom: 0; }
}

.chapter .chapter-name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  background: #f5f5f5;
  border-radius: 6px;
  box-sizing: border-box;
  transition: background-color 0.2s;
  &:hover { background: #efefef; }
  .chapter-title {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .chapter-no {
    flex-shrink: 0;
    font-weight: 500;
  }
  .chapter-label {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .chapter-arrow {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    .arrow {
      width: 12px;
      height: 7px;
      opacity: 0.45;
      transition: transform 0.2s;
    }
    &.open .arrow { transform: rotate(180deg); }
  }
}

.lessons {
  position: relative;
  padding: 12px 0 4px 8px;
  &::before {
    content: '';
    position: absolute;
    left: 22px;
    top: 22px;
    bottom: 22px;
    width: 1px;
    background: #e5e5e5;
  }
}

.lesson {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0 8px 4px;
  font-size: 13px;
  line-height: 1.5;
  cursor: pointer;
  transition: color 0.2s;
  .lesson-icon {
    position: relative;
    z-index: 1;
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    img {
      display: block;
      width: 20px;
      height: 20px;
    }
  }
  .lesson-name {
    flex: 1;
    min-width: 0;
    color: #333;
    word-break: break-all;
  }
  &:hover .lesson-name { color: $primary-dark; }
  &.active .lesson-name {
    color: #1687de;
    font-weight: 500;
  }
}

.paper-area { padding: 24px; }
.paper-list { list-style: none; padding: 0; margin: 0; }
.paper-item {
  display: flex; align-items: center; justify-content: space-between;
  padding: 16px 20px; border: 1px solid #e3e3e3; border-radius: 10px; margin-bottom: 16px;
  background: #fff; transition: all .2s;
  &:hover { border-color: $primary-dark; box-shadow: 0 2px 8px $primary-shadow; }
  .paper-info { flex: 1; }
  .paper-name { font-size: 15px; color: #333; font-weight: bold; margin-bottom: 6px; }
  .paper-meta { font-size: 13px; color: #999; display: flex; gap: 24px; }
}

.paper-stats {
  display: flex; align-items: center; gap: 16px; margin-top: 6px; font-size: 12px; color: #666;
  .rate { font-weight: bold; &.high { color: #67c23a; } &.mid { color: $accent; } &.low { color: #f56c6c; } }
  .rate-bar { width: 80px; height: 4px; background: #ededed; border-radius: 2px; overflow: hidden;
    .filled { height: 100%; border-radius: 2px; }
  }
}

.last-record { font-size: 12px; color: $accent; margin-top: 4px; }

.paper-btn {
  display: inline-block; padding: 6px 20px; border-radius: 14px;
  background: $primary-dark; color: #fff; font-size: 13px; cursor: pointer;
  text-decoration: none; border: none; transition: all .2s;
  &:hover { background: $primary; }
  &.outline { background: #fff; color: $primary-dark; border: 1px solid $primary-dark; &:hover { background: $primary-light; } }
}

.confirm-overlay {
  position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,.45); z-index: 300;
  display: flex; align-items: center; justify-content: center;
}
.confirm-box {
  background: #fff; border-radius: 14px; width: 360px; padding: 32px 28px 24px; text-align: center;
  box-shadow: 0 12px 40px rgba(0,0,0,.15);
}
.confirm-icon { width: 52px; height: 52px; border-radius: 50%; margin: 0 auto 16px; display: flex; align-items: center; justify-content: center; font-size: 26px; &.warn { background: #fef0f0; color: #f56c6c; } }
.confirm-title { font-size: 16px; font-weight: bold; color: #333; margin-bottom: 8px; }
.confirm-desc { font-size: 14px; color: #999; line-height: 1.6; margin-bottom: 24px; }
.confirm-actions {
  display: flex; gap: 12px; justify-content: center;
  .btn { flex: 1; padding: 10px 0; border-radius: 22px; font-size: 14px; cursor: pointer; transition: all .2s; border: none; }
  .btn-cancel { background: #f5f5f5; color: #666; &:hover { background: #eee; } }
  .btn-danger { background: #f56c6c; color: #fff; &:hover { background: #e84d4d; } }
}

.mode-overlay {
  position: fixed; inset: 0; background: rgba(0,0,0,.45); z-index: 200;
  display: flex; align-items: center; justify-content: center;
}
.mode-dialog {
  background: #fff; border-radius: 12px; width: 380px; padding: 28px 32px;
  box-shadow: 0 8px 32px rgba(0,0,0,.15); animation: popIn .25s ease;
  .md-title { font-size: 17px; font-weight: bold; color: #333; text-align: center; margin-bottom: 24px; }
  .md-options { display: flex; gap: 16px; margin-bottom: 20px; }
  .md-opt {
    flex: 1; border: 2px solid #e3e3e3; border-radius: 10px; padding: 20px 12px;
    text-align: center; cursor: pointer; transition: all .2s; background: #fafafa;
    &:hover { border-color: $primary-dark; background: $primary-light-3; }
    .md-icon { width: 44px; height: 44px; border-radius: 50%; margin: 0 auto 10px; display: flex; align-items: center; justify-content: center; font-size: 20px; }
    .md-name { font-size: 15px; font-weight: bold; color: #333; margin-bottom: 4px; }
    .md-desc { font-size: 12px; color: #999; }
    &.mode-answer .md-icon { background: $primary-light; color: $primary-dark; }
    &.mode-back .md-icon { background: #fff5e6; color: #e6a23c; }
  }
  .md-cancel {
    display: block; width: 100%; padding: 10px 0; border-radius: 8px;
    border: 1px solid #ddd; background: #fff; color: #666; font-size: 14px;
    cursor: pointer; transition: all .2s; text-align: center;
    &:hover { background: #f5f5f5; }
  }
}

@keyframes popIn {
  from { opacity: 0; transform: scale(.9); }
  to { opacity: 1; transform: scale(1); }
}

.link-btn{
  text-decoration: underline;
}

.page-title {
  height: 80px;
  line-height: 80px;
  box-sizing: border-box;
  padding: 0 30px;
    border-bottom: 1px solid #f2f2f2;
    margin-bottom: 30px;
    .title-bar {
        display: inline-block;
        width: 6px;
        height: 18px;
        background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
        border-radius: 0 !important;
        margin-right: 10px;
    }

    .title-text {
      font-size: 18px;
      font-weight: bold;
      color: #333;
    }
  }
</style>
